
import LandingReviewsCarousel from './LandingReviewsCarousel.vue'
import LoadingContainer from '@/components/ui/LoadingContainer.vue'
import { Cms } from '@/helpers/cms'

export default {
  components: { LandingReviewsCarousel, LoadingContainer },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      content: null
    }
  },
  async fetch () {
    const cms = new Cms(this.$axios)
    const { data } = await cms.get(
      `${this.$config.cmsBaseURL}/api/customer-review-carousel`,
      { params: { 'populate[0]': 'reviews', locale: this.$i18n.locale } }
    )
    this.content = data.attributes
  }
}
